{
  "page_title": "Text messages",
  "heading": "Text messages",
  "error": "Error loading data",
  "empty_state": {
    "scheduled_title": "No text messages scheduled yet!",
    "scheduled_byline": "To add a text message, edit an item on the <2>schedule tab</2>, and click on the <4 /> icon (top right)",
    "sent_title": "No text messages sent yet!",
    "recipient_title": "Add a recipient to get started",
    "recipient_byline": "Keep your group up to date by adding them as a text message recipient",
    "recipient_hint": "(psst.. if you want them to have access to adding or editing your schedule, add them as a collaborator by clicking share above)",
    "recipient_add": "Add recipient"
  },
  "upgrade_state": {
    "title": "Upgrade to Plus to unlock text messages",
    "body": "Text messages are a powerful way to keep people up-to-date with your schedule! Upgrade to Plus to unlock this feature.",
    "cta": "Upgrade to Plus",
    "schedule_more": "Want to schedule more text messages? Upgrade to Plus to continue using this feature."
  },
  "sort": {
    "label": "Change sort order",
    "desc": "Newest first",
    "asc": "Oldest first"
  },
  "nav": {
    "all": "All",
    "sent": "Sent",
    "scheduled": "Scheduled"
  },
  "delete_confirm": {
    "title": "Delete this message?",
    "confirm": "Delete"
  },
  "delivery_failures_one": "{{count}} delivery failure",
  "delivery_failures_other": "{{count}} delivery failures",
  "edit_action": "Edit",
  "delete_action": "Delete",
  "everyone_one": "Everyone",
  "everyone_other": "Everyone ({{count}} people)",
  "edit_message_modal": {
    "title": {
      "create": "Schedule a text message for {{title}}",
      "edit": "Scheduled text message for {{title}}"
    },
    "entry_not_found": "Item not found"
  },
  "add_a_message": "Add a message"
}
